import React from "react";
import ReactECharts from "echarts-for-react"; // Import ECharts for React
import moment from "moment";
import download from "./downloadCSV.jpg";

import { min } from "lodash";

class HistoricInflowChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#333',
          borderColor: '#888',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
          },
          
        },
        
        grid: {
          top: '15%',
          bottom: '20%',
          left: '10%',
          right: '23%',
        },
        xAxis: {
          type: 'category',
          data: this.props.dates,
          axisLabel: {
            formatter: (value) => {
              return window.innerWidth > 1000
                ? moment(new Date(value)).format("DD MMM YYYY")
                : moment(new Date(value)).format("MMM YYYY");
            },
          },
          name: 'Date',
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontWeight: 'bold', // Makes the axis name bold
            fontSize: 12, // Adjusts font size (optional)
            color: '#000', // Sets text color (optional)
        },
          axisLine: {
            lineStyle: {
              color: '#000000',
            },
          },
        },
        yAxis: {
          type: 'value',
          name: 'Inflow (Cusecs)',
          position: "left",
          nameLocation: "middle",
          nameGap: 50,
          nameTextStyle: {
            fontWeight: 'bold', // Makes the axis name bold
            fontSize: 12, // Adjusts font size (optional)
            color: '#000', // Sets text color (optional)
        },
          axisLine: {
            lineStyle: {
              color: '#000000',
            },
      
            
          },
          axisLabel: {
            formatter: function(value) {
              return Math.trunc(value); // Truncate the value to remove decimals
            }
          },
          max: Math.max(...this.props.flow_returnPer)*1.025,
          min: 0,
          interval: (Math.max(...this.props.flow_returnPer) / 8),
        },
        series: [
          {
            name: 'Streamflow (m3/s)',
            data: this.props.data,
            type: 'line',
            smooth: true,
            symbol: 'none',  // No markers (data points)

            lineStyle: {
              width: 3,
              color: '#26a0fc',
            },
            markArea: {
      itemStyle: {
        opacity: 0.8
      },
      data: [
        // First range
        [{
          
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[4],
        }, {
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[5], // Adding 1/8th
          itemStyle: {
            color: 'rgb(178,117,175)'
          }
        }],
        // Second range
        [{
        
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[3],
        }, {
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[4],
          itemStyle: {
            color: 'rgb(243,93,80)'
          }
        }],
        // Third range
        [{
        
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[2],
        }, {
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[3],
          itemStyle: {
            color: 'rgb(253,141,20)'
          }
        }],
        // Fourth range
        [{
          
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[1],
        }, {
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[2],
          itemStyle: {
            color: 'rgb(255,174,66)'
          }
        }],
        // Fifth range
        [{
         
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[0],
        }, {
          yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[1],
          itemStyle: {
            color: 'rgb(255,227,109)'
          }
        }]
      ]
    }
           
          },
        ],
        toolbox: {
          show: true,
          feature: {
          
            magicType: {
              type: ["bar", "line"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            saveAsImage: {
              type: ["png", "svg"],
              title: "Save Chart",
              name: `${this.props.rname[1]
                .split("(")[0]
                .replace(" ", "_")}_HIS_${this.props.date}`,
            },
            myExportCSV: {  // Custom CSV button
              show: true,
              title: "Export to CSV",
              icon: `image://${download}`,  // You can replace this with the path to your custom icon
              onclick: this.exportToCSV,
            },
          
          },
      
        },
      
      
          title: {
            text: this.props.rname[0],
            subtext: this.props.rname[1],
            textStyle: {
              fontSize: 16,
              color: '#0000ff',

            },
            subtextStyle: {
              fontSize: 14,
              color: '#0000ff',

            },
            textAlign: 'center',  // Centering the title
            subtextAlign: 'center',  // Centering the subtext
            x: 'center',  // Horizontal position of the title (centered)
            y: 'top'  // Vertical position of the title (adjust as needed)
          },
         
        


     


        
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
        ],
      },
    };
  };
  exportToCSV = () => {
    const { dates, data, title, rname, date } = this.props;

    // Start the CSV content with headers
    let csvContent = `"Date","Inflow (cusecs)"\n`;

    // Loop through dates and data to generate rows
    dates.forEach((dateValue, index) => {
        // Format the date using moment.js
        const formattedDate = moment(dateValue).format("DD MMM YYYY");

        // Get the corresponding data value
        const inflowValue = data[index] || ''; // Handle missing data gracefully

        // Append the row to the CSV content
        csvContent += `${formattedDate},${inflowValue}\n`;
    });

    // Create a Blob containing the CSV data
    const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });

    // Create a link element to trigger download
    const a = document.createElement('a');
    const filename = `${rname[1].split("(")[0].replace(" ", "_")}_HIS_${date}.csv`;

    a.href = URL.createObjectURL(csvBlob);
    a.download = filename;
    a.click();
};


  render() {
    console.log("data from hist",this.props.dates,this.props.data)
    return (
      <div>
            <div className="legend-container" style={{display: "grid",justifyContent: "space-between",position: "relative"}}>
            <div className="legend-item">
            <strong>Return Periods</strong>
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(255,227,109)' }}></span>
            5 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[0])}
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(255,174,66)' }}></span>
            10 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[1])}
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(253,141,20)' }}></span>
            20 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[2])}
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(243,93,80)' }}></span>
            30 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[3])}
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(178,117,175)' }}></span>
            50 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[4])}
          </div>
          <div className="legend-item" style={{ paddingTop: "10px" }}>
            <span className="legend-line" style={{ backgroundColor: '#26a0fc' }}></span>
            <strong>Historic Simulation</strong>
          </div>
        </div>

        <ReactECharts
          option={this.state.options}
          style={{ height: '350px', width: '100%' }}
        />
      </div>
    );
  }
}

export default HistoricInflowChart;
